module.exports = __webpack_public_path__ + "img/status_7.dd918dad.png";